export default class Lightbox {
	static init() {
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			return;
		}

		this.setScrollbarWidth();

		document.querySelector('body').addEventListener('openLightbox', (e) => {
			const lightboxElement = e.target && e.target.closest('.innsbruck-lightbox');
			if(lightboxElement) {
				Lightbox.openLightbox(lightboxElement);
			}
		});

		let $dialogTrigger = $('.innsbruck-lightbox-trigger');
        $dialogTrigger.on('click', function(e) {
            const isLinkWidget = $(this).hasClass('link-widget-link');
			const lightboxElement = document.getElementById($(this).attr('data-target-id'));
            if (isLinkWidget) {
                e.preventDefault();
                let iframeUri = $(this).attr('data-overlay-uri');
                Lightbox.openLightboxWithIframeUri(lightboxElement, iframeUri);
            } else {
                Lightbox.openLightbox(lightboxElement);
                return false;
            }
		});

		$(window).on("resize", function () {
			if ($('.innsbruck-lightbox').length && $('.innsbruck-lightbox').is(':visible')) {
				var popheighton = $('.innsbruck-lightbox .innsbruck-lightbox__content-box').height() + 60;
				var winHeight = $(window).height();
				if (popheighton > winHeight) {
					$('.innsbruck-lightbox .innsbruck-lightbox__content').addClass('taller');

				} else {
					$('.innsbruck-lightbox .innsbruck-lightbox__content').removeClass('taller');
				}
			}
		});

		//Close popup
        document.addEventListener('click', (e) => {
            if(!e.target || !e.target.closest('.innsbruck-lightbox__close-button,.innsbruck-lightbox__modal-backdrop')) {
                return; // not a popup close
            }
            e.preventDefault();
            const lightboxElement = e.target.closest('.innsbruck-lightbox');
            this.closeLightbox(lightboxElement);
        });

		// ESC close
        $('body').on('keyup', (e) => {
            if (e.key === "Escape") {
                // when the escape closes a lightbox
                $('html').removeClass('html--lightbox-overflow-hidden');
            }
        })

		var easeVal = "expo.inOut";

		$(".innsbruck-lightbox__close-button").hover(function () {
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar1", {rotation: -45}, {rotation: 0, duration: 0.25, ease: easeVal});
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar3", {rotation: 45}, {rotation: 0, duration: 0.25, ease: easeVal});
		}, function () {
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar1", {rotation: 0}, {rotation: -45, duration: 0.25, ease: easeVal});
			gsap.fromTo(".innsbruck-lightbox__nav-bars .bar3", {rotation: 0}, {rotation: 45, duration: 0.25, ease: easeVal});
		});
	}

	static setScrollbarWidth() {
		// Popup diff for scrollbar
		const popDiff = () => {
			const screenWidth = screen;
			const bodyWidth = document.querySelector('body');
			const scrollDiff = screenWidth.width - bodyWidth.offsetWidth;

			const doc = document.documentElement
			doc.style.setProperty('--pop-diff', `${scrollDiff}px`)
		}
		window.addEventListener('resize', popDiff)
		popDiff();

		// Detect Mac and Window
		if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
			$("body").addClass("mac");
		} else {
			$("body").addClass("pc");
		}
	}

	constructor(element) {
	}

	static openLightbox(lightboxElement) {
		$('html').addClass('html--lightbox-overflow-hidden');

        lightboxElement.showModal();
		lightboxElement.setAttribute('style', '');
		$(lightboxElement).find('.innsbruck-lightbox__content-block').outerHeight(true);

		$('.innsbruck-lightbox .innsbruck-lightbox__modal-backdrop').fadeTo(250, 1);
		$(lightboxElement).focus();

        let $iframe = $(lightboxElement).find('iframe');
        if (!$iframe) return;

        let lightboxInterval = $(lightboxElement).attr('data-interval');
        if (!!lightboxInterval) {
            clearInterval(lightboxInterval);
        }
        lightboxInterval = setInterval(() => {
            let isOverflowing = ($iframe.contents().height() > $(window).height() - 222);
            if (isOverflowing) {
                $(lightboxElement).addClass('innsbruck-lightbox--is-overflowing');
                iframeScrollHandler();
            }
        }, 250);
        $(lightboxElement).attr('data-interval', lightboxInterval);

        let iframeScrollHandler = function(e) {
            let isAtTop;
            let isAtBottom;
            let offset = 64;

            if (e) {
                isAtTop = $(e.target).scrollTop() < offset;
                isAtBottom = $(e.target).height() - ($iframe.height() + $(e.target).scrollTop()) < offset;
            } else {
                isAtTop = $iframe.contents().scrollTop() < offset;
                isAtBottom = $iframe.contents().height() - ($iframe.height() + $iframe.contents().scrollTop()) < offset;
            }

            if (isAtTop) {
                $(lightboxElement).addClass('innsbruck-lightbox--is-at-top');
            } else {
                $(lightboxElement).removeClass('innsbruck-lightbox--is-at-top')
            }

            if (isAtBottom) {
                $(lightboxElement).addClass('innsbruck-lightbox--is-at-bottom');
            } else {
                $(lightboxElement).removeClass('innsbruck-lightbox--is-at-bottom');
            }
        }

        // Reset scroll indicator classes status
        $(lightboxElement).on("close", () => {
            $(lightboxElement).removeClass('innsbruck-lightbox--is-overflowing');
            $(lightboxElement).addClass('innsbruck-lightbox--is-at-top');
            $(lightboxElement).removeClass('innsbruck-lightbox--is-at-bottom');
            // Clear interval
            let lightboxInterval = $(lightboxElement).attr('data-interval');
            if (!!lightboxInterval) {
                clearInterval(lightboxInterval);
            }

            const iframe = lightboxElement.querySelector('iframe');
            if (!iframe) return;

            // Ensure that iframe is empty before opening the lightbox
            try {
                if (iframe.contentWindow && iframe.contentWindow.document) {
                    iframe.contentWindow.document.open();
                    iframe.contentWindow.document.write("");
                    iframe.contentWindow.document.close();
                }
            } catch (e) {
                // Swallow any cross-origin related errors; we'll still set src below
            }
        })
	}

    static closeLightbox(lightboxElement) {
        $(lightboxElement).fadeOut(300, function () {
            $(this).find('.innsbruck-lightbox__modal-backdrop').fadeOut(250, function () {
                $('html').removeClass('html--lightbox-overflow-hidden');
            });
            lightboxElement.close();
        });
    }

    static openLightboxWithIframeUri(lightboxElement, iframeUri) {
        // Don't open lightbox if Neos backend is open
        if (window.neos) {
            return;
        }

        const iframe = lightboxElement.querySelector('iframe');
        if (!iframe) return;

        // Load next page in iframe
        iframe.setAttribute('src', iframeUri);

        // Wait 0.5 seconds before opening to reduce flickering
        setTimeout(() => {
            Lightbox.openLightbox(lightboxElement);
        }, 500);
    }
}
